import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./DevelopmentBanner.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";
import { useServiceSection } from "../../../../../context/ServicePageContext";
import { resolveMediaUrl } from "../../../../../utils/resolveMediaUrl";

const DevelopmentBanner = () => {
  const { section, loading } = useServiceSection("development-banner");

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url;
    return url ? resolveMediaUrl(url) : "";
  }, [section]);

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="dev-banner">
      {bgSrc ? <img src={bgSrc} alt="" className="dev-banner__bg" /> : null}
      <div className="dev-banner__overlay" />

      <div className="dev-banner__content">
        {fields.label ? (
          <CmsText
            content={fields.label}
            as="span"
            className="dev-banner__label"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h1" />
        ) : null}

        {fields.description ? (
          <RichTextContent content={fields.description} />
        ) : null}

        <div className="dev-banner__actions">
          {fields.buttonOutlineLink ? (
            <Link
              to={fields.buttonOutlineLink}
              className="dev-btn-outline buttonclip"
            >
              <CmsText content={fields.buttonOutlineText} as="span" />
            </Link>
          ) : null}

          {fields.buttonPrimaryLink ? (
            <Link
              to={fields.buttonPrimaryLink}
              className="buttonclip dev-btn-primary"
            >
              <CmsText content={fields.buttonPrimaryText} as="span" />
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default DevelopmentBanner;
